import { Navigate } from "react-router-dom";
import { useSession } from "../../session/SessionContext";
import OrganizationSelect from "../OrganizationSelect/OrganizationSelect";
import NoAccess from "../NoAccess/NoAccess";

const Home: React.FC = () => {
  const { user } = useSession();
  if (user?.role === "operator") {
    return <OrganizationSelect />;
  }
  if (user?.role === "member" && user.organization) {
    return <Navigate to={`/${user.organization}`} replace />;
  }
  return <NoAccess />;
};

export default Home;
